// extracted by mini-css-extract-plugin
module.exports = {"skipToMainContent":"skip-to-main-content_skipToMainContent__L9ZiW","hidden":"skip-to-main-content_hidden__pDgQM","visible":"skip-to-main-content_visible__t3g3D"};